export default 'https://tme.understood.org/assets/Light_Texture03.6bf7eae2.jpg'